import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { i18nCategoryFilter, subCategoryFilter, categoryIconFilter, parentCategoryFilter } from "app/filters/ngFilters";
import { trackEvent } from "../SWReactTableTrackEvent";

export const ReferringCategoryDashboardCell: FC<ITableCellProps> = ({ value, tableOptions }) => {
    return (
        <div className="swTable-categoryCell">
            <i className={`sprite-category u-right-padding-6 ${categoryIconFilter()(parentCategoryFilter()(value))}`} />
            <span
                title={i18nCategoryFilter()(value)}
                onClick={() => {
                    trackEvent(tableOptions, "Internal Link", value, "click");
                }}
            >
                {subCategoryFilter()(value)}
            </span>
        </div>
    );
};
ReferringCategoryDashboardCell.displayName = "ReferringCategoryDashboardCell";
